import { IApiPermissionMatrix, IApiPermissionResponse } from '@core/services/permission/permission.interface';
import { IPermissionsPayload } from '@app/interfaces/permissions.interface';
import { ORG_PERMITTED_ACCOUNTS_URL } from '@app/constants/endpoints';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { IAccountsPermitted } from '@app/interfaces';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PermissionApi {
	constructor(private apiFacade: ApiFacadeService) {}

	public getMatrix(): Observable<IApiPermissionMatrix> {
		const url = 'permission-manager/get-permissions-matrix';

		return this.apiFacade.get<IApiPermissionMatrix>(url);
	}

	public update(payload: IPermissionsPayload): Observable<Omit<IApiPermissionResponse, 'permissions'>> {
		const url = 'permission-manager/set-permissions';

		return this.apiFacade.post(url, payload);
	}

	public getPermittedAccounts(permission: string): Observable<IAccountsPermitted> {
		return this.apiFacade.post(ORG_PERMITTED_ACCOUNTS_URL, { permission });
	}
}
